import '../../assets/css/boasVindas.css'
import '../../assets/css/scrollbar.css'
import ReactPlayer from 'react-player';
import Rodape from './Rodape';

import thumbnailRet from '../../assets/imgs/bemVindo/thumbnailRet.png'
import { useState } from 'react';

const widthWindow = window.screen.width
const heightWindow = window.screen.height


const userAgent = navigator.userAgent || navigator.vendor || window.opera;

const isAndroid = /android/i.test(userAgent);
const isApple = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

const VideoComp = ({url,classObj, ativaResp})=>{
    const [play, setPlay] = useState(false);
    const [videoStarted, setVideoStarted] = useState(false);

    return <ReactPlayer className={`player ${classObj}`} url={url} controls  
        light={thumbnailRet}
        width={ativaResp ? widthWindow*0.80+"px" : widthWindow*0.53+"px"}  
        height={ativaResp ? widthWindow*0.5+"px" : widthWindow*0.3+"px"}  
        style={{border: '1px solid #FFFFFF',  width: widthWindow*0.53+"px",
        height: widthWindow*0.3+"px" }} 
        light={!play && !videoStarted ? thumbnailRet : false}
        playing={play}
        onClickPreview={() => setPlay(true)}
        onPlay={() => {
        setPlay(true);
        setVideoStarted(true); // indica que o vídeo já começou
        }}
        onPause={() => setPlay(false)}
        onEnded={() => {
        setPlay(false);
        setVideoStarted(false); // volta capa ao terminar
        }}/>
}





export default function BoasVindas({ativaResp}){



    return <>
    <div className={`containerBoasVindas scrollbar`} style={{ overflowX: 'hidden',  position: 'relative'}}>
        <div className="title">
            <div className="logobabita"></div>
        </div>

        {ativaResp ? 
            <>
                <div className="bubble" style={{'--topBubble': '-6vh', '--leftBubble': '0.3vh', '--sizeBubble': '17vh'}}></div>
                <div className="bubble" style={{'--topBubble': '14vh', '--leftBubble': '-5vh', '--sizeBubble': '13vh'}}></div>
                <div className="bubble" style={{'--topBubble': '-1vh', '--rightBubble': '-4vh', '--sizeBubble': '13vh'}}></div>
                <div className="bubble" style={{'--bottomBubble': '-5vh', '--leftBubble': '2vh', '--sizeBubble': '17vh'}}></div>
                <div className="bubble" style={{'--bottomBubble': '-12vh', '--rightBubble': '15vh', '--sizeBubble': '17vh'}}></div>
                <div className="bubble" style={{'--bottomBubble': '10vh', '--rightBubble': '5vh', '--sizeBubble': '17vh'}}></div>  

                <div className="bubble" style={{'--bottomBubble': '40vw', '--rightBubble': '58vw', '--sizeBubble': '20vw'}}></div> 
                <div className="bubble" style={{'----topBubble': '28vw', '--rightBubble': '15vw', '--sizeBubble': '35vw'}}></div> 
            </> : 
            <>
            <div className="bubble" style={{'--topBubble': '-6vw', '--leftBubble': '0.3vw', '--sizeBubble': '17vw'}}></div>
            <div className="bubble" style={{'--topBubble': '14vw', '--leftBubble': '-5vw', '--sizeBubble': '13vw'}}></div>
            <div className="bubble" style={{'--topBubble': '-1vw', '--rightBubble': '-4vw', '--sizeBubble': '13vw'}}></div>
            <div className="bubble" style={{'--bottomBubble': '-5vw', '--leftBubble': '2vw', '--sizeBubble': '17vw'}}></div>
            <div className="bubble" style={{'--bottomBubble': '-12vw', '--rightBubble': '15vw', '--sizeBubble': '17vw'}}></div>
            <div className="bubble" style={{'--bottomBubble': '10vw', '--rightBubble': '5vw', '--sizeBubble': '17vw'}}></div>  

            </>}

            <div className="subtitle1">Nossa história: <br /> Como tudo começou</div>
            <VideoComp ativaResp={ativaResp} url={"https://babita.com.br/BABITA OFICIAL.mp4"} classObj={"playerPrimeiro"}/>
            <div className="dataVideos dataPrimeiroVideo">Outubro/2024</div>

        {/* <div className="divisor"></div> */}

        

        <div className='subtitleApp2'>A história continua</div>

        <VideoComp ativaResp={ativaResp} url={"https://babita.com.br/ANDRE.mp4"} classObj={"playerSegundo"}/>
        <div className="dataVideos dataSegundoVideo">Julho/2025</div>
    

        <div className="relacionamento">
            <div className="intro">
                Mais que atendimento: <br />Relacionamento Babita.<br />
                <span>Criamos uma linha de atendimento exclusiva para revendedores:</span><br />
            </div>


            {/* <div className="textInfoWp" >
                <div className="icon"></div>
                <div className="textEmailsInfo">
                    (31) 98652-4600 <br />
                    Segunda a sexta: 9h às 18h
                </div>
            </div> */}

            <div className="textInfoWp appLink" onClick={()=>window.location.href = 'https://wa.me/+5531986524600'}>
                        <div className="icon"></div>
                        <div className="textEmailsInfo">
                    (31) 98652-4600 <br />
                    Segunda a sexta: 9h às 18h
                </div>
            </div>

            <div className="textInfoTel">
                <div className="icon"></div>
                <div className="textEmailsInfo">
                    (31) 3270-7000 <br />
                    Segunda a sexta: 9h às 18h
                </div>
            </div>
            
            <div className="textInfoEmail">
                <div className="icon"></div>
                <div className="textEmailsInfo">
                    relacionamento@babita.com.br
                </div>
            </div>

            
            
            
            
        </div>

    <Rodape />
    </div>
    </>
}






// {isAndroid || !isApple ? 
//     <div className="appleLink" onClick={()=>window.location.href = 'https://apps.apple.com/br/app/babita/id6448415780'}>
//         <div className="icon"></div>
//         <div className="textIcon">
//             <div>Baixe na</div>
//             <div>Apple Store</div>
//         </div>
//     </div> :
//     <div className="googlePlayLink" onClick={()=>window.location.href = 'https://play.google.com/store/apps/details?id=br.com.babita.pedidos&hl=pt_BR'}>
//         <div className="icon"></div>
        // <div className="textIcon">
        //     <div>Baixe na</div>
        //     <div>Play Store</div>
        // </div>
//     </div>
// }